import { render, staticRenderFns } from "./CdcCustomerDetail.vue?vue&type=template&id=8bfc1504&"
import script from "./CdcCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./CdcCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports